import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CommentEditorSource } from '../redux/types';
import { CommentEditorContext, EditorContext } from '../context';
import { useEditorDraftActions } from './useEditorDraftActions';
import { useIsCommentEditorEmpty } from './useIsCommentEditorEmpty';
/**
 * Provides a function that will cancel a comment! Completely! It'll be removed from drafts
 * and we'll close the relevant editor.
 *
 * Relies on all the contexts provided by `<CommentEditorProviders />`,
 * so be sure you have it set up first!
 */ export function useCommentCancelAction({ onCancel  } = {}) {
    const { t  } = useTranslation();
    const { editorId , editorSource , collapseEditor  } = useContext(CommentEditorContext);
    const { api: editorApi  } = useContext(EditorContext);
    const { removeEditorDraft  } = useEditorDraftActions(editorId);
    const isEmpty = useIsCommentEditorEmpty();
    return useCallback(()=>{
        removeEditorDraft();
        if (editorSource !== CommentEditorSource.Edit && !isEmpty) {
            const cancel = confirm(t('commentbox.editor.cancel.confirm'));
            if (!cancel) {
                return;
            }
            editorApi === null || editorApi === void 0 ? void 0 : editorApi.clearEditor(true);
        }
        collapseEditor();
        onCancel && onCancel();
    }, [
        isEmpty,
        editorSource,
        removeEditorDraft,
        t,
        editorApi,
        onCancel,
        collapseEditor
    ]);
}
